import { useDashboardChartFormProcess } from '#pages/DashboardChartForm/hooks/useDashboardChartFormProcess';
import { useDashboardCharFormExerciseState } from '#pages/DashboardChartForm/states/dashboardCharFormExerciseState';
import { Input } from '#shared/Input/Input';
import { useExercisePresetRecoil } from '#states/exercisePresetsState';
import { IExercisePresetWorkoutSet } from '#types/exercisePresets';
import { produce } from 'immer';
import { ChangeEvent, Fragment } from 'react';
import { ExerciseSet } from './ExerciseSet';

interface SetTypeProps {
  index: number;
  sets: IExercisePresetWorkoutSet[];
}
export const SetList = ({ index: presetIndex, sets }: SetTypeProps) => {
  if (!sets) return null;

  return (
    <>
      {sets.map((_, index) => (
        <Fragment key={index}>
          <SetInput presetIndex={presetIndex} sets={sets} setIndex={index} />
        </Fragment>
      ))}

      <ExerciseSet sets={sets} index={presetIndex} />
    </>
  );
};

interface SetInputProps {
  // preset index
  presetIndex: number;
  setIndex: number;
  sets: IExercisePresetWorkoutSet[];
}

const SetInput = ({ presetIndex, setIndex, sets }: SetInputProps) => {
  const { setExercisePresets } = useExercisePresetRecoil();

  const { setRecords } = useDashboardCharFormExerciseState();

  const { tab } = useDashboardChartFormProcess();

  const isSelectPresetPage = tab === '프리셋 선택';

  const setInputList = [
    { name: 'round', displayName: '세트', condition: true },
    {
      name: 'weight',
      displayName: 'kg',
      condition: sets[setIndex].setType === 'REPWEIGHT'
    },
    {
      name: 'time',
      displayName: 'sec',
      condition:
        sets[setIndex].setType === 'REPTIME' ||
        sets[setIndex].setType === 'TIME'
    },
    {
      name: 'reps',
      displayName: '회',
      condition: sets[setIndex].setType.includes('REP')
    }
  ];

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (isSelectPresetPage) {
      setExercisePresets(
        produce(draft => {
          const exercise = draft.exercisePresetWorkout[presetIndex];
          const setToUpdate = exercise.sets[setIndex];

          if (setToUpdate) {
            switch (name) {
              case 'weight':
                setToUpdate.weight = Number(value);
                break;
              case 'reps':
                setToUpdate.reps = Number(value);
                break;
              case 'time':
                setToUpdate.time = Number(value);
                break;
              case 'round':
                setToUpdate.round = Number(value);
                break;
            }
          }
        })
      );
    }

    if (isSelectPresetPage) return;
    setRecords(prevState =>
      produce(prevState, draft => {
        const exercise = draft[presetIndex];
        const setToUpdate = exercise.sets[setIndex];

        if (setToUpdate) {
          switch (name) {
            case 'weight':
              setToUpdate.weight = Number(value);
              break;
            case 'reps':
              setToUpdate.reps = Number(value);
              break;
            case 'time':
              setToUpdate.time = Number(value);
              break;
            case 'round':
              setToUpdate.round = Number(value);
              break;
          }
        }
      })
    );
  };

  return (
    <div className="my-12 flex justify-between">
      {setInputList.map((setInput, index) => {
        const currentSet = sets[setIndex];
        const getCurrentValue = () => {
          switch (setInput.name) {
            case 'weight':
              return currentSet.weight;
            case 'time':
              return currentSet.time;
            case 'reps':
              return currentSet.reps;
            case 'round':
              return currentSet.round;
            default:
              return '';
          }
        };

        return (
          <div
            key={index}
            style={{ display: setInput.condition ? 'flex' : 'none' }}
            className="flex gap-4"
          >
            {/* {setInput.name === 'round' ? (
              <Input
                inputWrapperStyle={{ width: '60px' }}
                value={currentSet.round}
                style={{ textAlign: 'center', padding: '0px' }}
                name={setInput.name}
                disabled
              />
            ) : (
              <Input
                type="number"
                inputWrapperStyle={{ width: '60px' }}
                placeholder="-"
                style={{ textAlign: 'center', padding: '0px' }}
                name={setInput.name}
                value={getCurrentValue()}
                onChange={e => onChange(e)}
              />
            )} */}

            <Input
              type="number"
              inputWrapperStyle={{ width: '60px' }}
              placeholder="-"
              style={{ textAlign: 'center', padding: '0px' }}
              name={setInput.name}
              value={getCurrentValue()}
              onChange={e => onChange(e)}
            />

            <div className="text-[#746f7e] flex items-center text-sm font-medium font-['Pretendard Variable']">
              {setInput.displayName}
            </div>
          </div>
        );
      })}
    </div>
  );
};
